import {
  LISTAR_CHAMADAS,
  LISTAR_CENTRO_DE_CUSTOS,
  LISTAR_CONFERENCIAS,
  LISTAR_TAGS,
  GERAR_DADOS_RELATORIO,
} from './mutation-types'
import relatorioChamadasHttpService from '../_services/RelatorioChamadasHttpService'

export default {
  listarRelatorioChamadas: async ({ commit }, body) => {
    try {
      const response = await relatorioChamadasHttpService.getrelatorios(body)
      commit(LISTAR_CHAMADAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarCentroDeCustos: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.getCentroDeCustos()
      commit(LISTAR_CENTRO_DE_CUSTOS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },

  listarConferencias: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.getConferencias()
      commit(LISTAR_CONFERENCIAS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listarTags: async ({ commit }) => {
    try {
      const response = await relatorioChamadasHttpService.getTags()
      commit(LISTAR_TAGS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  gerarRelatorio: async ({ commit }, { form, currentPage }) => {
    try {
      const response = await relatorioChamadasHttpService.gerarRelatorio(form, currentPage)
      commit(GERAR_DADOS_RELATORIO, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
